import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CtxComment } from './models';

export interface LoadingStatus {
    serverRequestInProgress: boolean;
    loaded: boolean;
}

export interface State extends EntityState<CtxComment>, LoadingStatus {}

export const adapter: EntityAdapter<CtxComment> = createEntityAdapter<CtxComment>();

export const initialState: State = adapter.getInitialState({
    serverRequestInProgress: false,
    loaded: false,
});
